export default {
  ticketInfo: 'Ticket Information',
  ticket_generating: 'Ticket generating',
  free_ticket: 'Free ticket',
  purchase_success: 'Purchase successful',
  periodicalInfo: 'Periodical Information',
  youMayNeedServices: 'You may also need the following services, which can be added below.',
  youMayNeedMoreServices: 'You may also need the following services.',
  safeTravel: 'Travel safely',
  securityReminder: 'Security reminder',
  weWontLeakInfo:
    'We will not disclose user information for any reason. If you receive information about exhibition changes or order abnormalities from unfamiliar numbers, do not trust them easily and beware of fraud!',
  electronicPeriodical: 'Electronic Periodical | Exhibitor Directory',
  clickToView: 'Click to view',
  myTickets: 'My Tickets',
  continueToBuy: 'Continue to buy',
  generatePoster: 'Generate Poster',
  notBookedHotel: "You haven't booked a hotel yet.",
  goToBook: 'Go to book',
  notAppliedVisa: "You haven't applied for a visa yet.",
  goToApply: 'Go to apply',
  subscribeMiniProgram: 'Follow the WeChat mini-program to get e-tickets.',
  subscribeOfficialAccount: 'Follow the WeChat official account to get e-tickets.',
  bookSuccess: 'Booking successful',
  bookFailed: 'Booking failed',
  bookNow: 'Book now',
  visa_application: 'Visa Application',
  express_handling: 'Express Handling',
  professional_customer_service: 'Professional Customer Service',
  itinerary_customization: 'Itinerary Customization',
  business_itinerary: 'Business Itinerary',
  personalized_customization: 'Personalized Customization',
  thoughtful_service: 'Thoughtful Service',
  success_desc:
    'The exhibition will be held on {lunchTime}. Please bring your original ID card to enter by swiping or exchange it for a paper admission pass at the on - site service desk! Wish you a successful visit!',
  failure_desc:
    'We are very sorry that your reservation has failed. Please place a new order or contact customer service for assistance.'
}
